import React from 'react';
import LoadingSmall from '../../components/LoadingSmall.js';
import axios from 'axios';
import { DateRangePicker, SingleDatePicker, DayPickerRangeController } from 'react-dates';
import moment from 'moment';
import Notification from '../../components/Notification';
import Select from 'react-select';

class account_settings extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            focused:null,
            currentPlan:this.defaultCurrentPlan(),
            plans:[],
            demo_ends_at:moment.utc(this.props.general.account.trial_ends_at),
        }


        console.dir(this.state.demo_ends_at);


    }

    defaultCurrentPlan = () => {
        return {
            label:null,
            value:null,
        };
    }

    updateDemoDate = () => {
        axios.put('/managment/set_demo_date',{
            trial_ends_at:this.state.demo_ends_at.format('YYYY-MM-DD')
        }).then(res => {
            Notification.success('Updated');
        });
    }

    componentWillMount() {
        axios.get('/managment/plans').then(res => {
            this.setState({
                plans:res.data,
            })
        });
    }

    getAllPlans = () => {
        return this.state.plans.map(plan => {
            return {
                value:plan.id,
                label:plan.name,
            }
        });
    }

    handlePlanChange = (e) => {
        this.setState({
            currentPlan:e,
        })
    }

    addPlan = () => {
        this.setState({
            currentPlan:this.defaultCurrentPlan(),
        })
    }

    render() {
        return (
            <div>
                <div className="row">
                    <div className="col-sm-12">
                        <div className="col-sm-5">
                            Demo ends at:
                        </div>

                        <div className="col-sm-5">
                            <SingleDatePicker
                                displayFormat="YYYY-MM-DD"
                                small={true}
                                date={this.state.demo_ends_at} // momentPropTypes.momentObj or null
                                onDateChange={demo_ends_at => this.setState({ demo_ends_at })} // PropTypes.func.isRequired
                                focused={this.state.focused} // PropTypes.bool
                                onFocusChange={({ focused }) => this.setState({ focused })} // PropTypes.func.isRequired
                                id="demo_ends_at" // PropTypes.string.isRequired,
                            />

                            <button className="btn btn-dark" onClick={this.updateDemoDate}>Save</button>
                        </div>

                    </div>
                </div>

                <div className="row m-t-20">
                    <div className="col-sm-12">
                        <div className="col-sm-6">
                            <Select
                                value={this.state.currentPlan.value}
                                onChange={this.handlePlanChange}
                                options={this.getAllPlans()}
                            />
                        </div>

                        <div className="col-sm-5">
                            <button className="btn btn-dark" onClick={this.addPlan}>Add</button>
                        </div>

                    </div>
                </div>
            </div>
        )
    }
}

export default account_settings;



// WEBPACK FOOTER //
// ./containers/adm/account_settings.js